import { jsx as p, Fragment as T, jsxs as W } from "react/jsx-runtime";
import * as c from "react";
import { forwardRef as A } from "react";
import { u as B } from "./index-BZPx6jYI.js";
import { u as V } from "./index-CqxPlD6w.js";
import "./index-2hJuj4UN.js";
function D(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function I(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function R(...e) {
  return (t) => e.forEach((n) => I(n, t));
}
function U(...e) {
  return c.useCallback(R(...e), e);
}
function q(e, t = []) {
  let n = [];
  function o(s, i) {
    const u = c.createContext(i), a = n.length;
    n = [...n, i];
    const l = (f) => {
      var S;
      const { scope: d, children: C, ...w } = f, h = ((S = d == null ? void 0 : d[e]) == null ? void 0 : S[a]) || u, b = c.useMemo(() => w, Object.values(w));
      return /* @__PURE__ */ p(h.Provider, { value: b, children: C });
    };
    l.displayName = s + "Provider";
    function m(f, d) {
      var h;
      const C = ((h = d == null ? void 0 : d[e]) == null ? void 0 : h[a]) || u, w = c.useContext(C);
      if (w) return w;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${s}\``);
    }
    return [l, m];
  }
  const r = () => {
    const s = n.map((i) => c.createContext(i));
    return function(u) {
      const a = (u == null ? void 0 : u[e]) || s;
      return c.useMemo(
        () => ({ [`__scope${e}`]: { ...u, [e]: a } }),
        [u, a]
      );
    };
  };
  return r.scopeName = e, [o, z(r, ...t)];
}
function z(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(s) {
      const i = o.reduce((u, { useScope: a, scopeName: l }) => {
        const f = a(s)[`__scope${l}`];
        return { ...u, ...f };
      }, {});
      return c.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function k(e) {
  const t = c.useRef(e);
  return c.useEffect(() => {
    t.current = e;
  }), c.useMemo(() => (...n) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...n);
  }, []);
}
function F({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [o, r] = L({ defaultProp: t, onChange: n }), s = e !== void 0, i = s ? e : o, u = k(n), a = c.useCallback(
    (l) => {
      if (s) {
        const f = typeof l == "function" ? l(e) : l;
        f !== e && u(f);
      } else
        r(l);
    },
    [s, e, r, u]
  );
  return [i, a];
}
function L({
  defaultProp: e,
  onChange: t
}) {
  const n = c.useState(e), [o] = n, r = c.useRef(o), s = k(t);
  return c.useEffect(() => {
    r.current !== o && (s(o), r.current = o);
  }, [o, r, s]), n;
}
var g = c.forwardRef((e, t) => {
  const { children: n, ...o } = e, r = c.Children.toArray(n), s = r.find(Z);
  if (s) {
    const i = s.props.children, u = r.map((a) => a === s ? c.Children.count(i) > 1 ? c.Children.only(null) : c.isValidElement(i) ? i.props.children : null : a);
    return /* @__PURE__ */ p(y, { ...o, ref: t, children: c.isValidElement(i) ? c.cloneElement(i, void 0, u) : null });
  }
  return /* @__PURE__ */ p(y, { ...o, ref: t, children: n });
});
g.displayName = "Slot";
var y = c.forwardRef((e, t) => {
  const { children: n, ...o } = e;
  if (c.isValidElement(n)) {
    const r = J(n);
    return c.cloneElement(n, {
      ...G(o, n.props),
      // @ts-ignore
      ref: t ? R(t, r) : r
    });
  }
  return c.Children.count(n) > 1 ? c.Children.only(null) : null;
});
y.displayName = "SlotClone";
var X = ({ children: e }) => /* @__PURE__ */ p(T, { children: e });
function Z(e) {
  return c.isValidElement(e) && e.type === X;
}
function G(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], s = t[o];
    /^on[A-Z]/.test(o) ? r && s ? n[o] = (...u) => {
      s(...u), r(...u);
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...s } : o === "className" && (n[o] = [r, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function J(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var K = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], x = K.reduce((e, t) => {
  const n = c.forwardRef((o, r) => {
    const { asChild: s, ...i } = o, u = s ? g : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(u, { ...i, ref: r });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), P = "Switch", [Q, le] = q(P), [Y, H] = Q(P), N = c.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: o,
      checked: r,
      defaultChecked: s,
      required: i,
      disabled: u,
      value: a = "on",
      onCheckedChange: l,
      form: m,
      ...f
    } = e, [d, C] = c.useState(null), w = U(t, (v) => C(v)), h = c.useRef(!1), b = d ? m || !!d.closest("form") : !0, [S = !1, j] = F({
      prop: r,
      defaultProp: s,
      onChange: l
    });
    return /* @__PURE__ */ W(Y, { scope: n, checked: S, disabled: u, children: [
      /* @__PURE__ */ p(
        x.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": S,
          "aria-required": i,
          "data-state": O(S),
          "data-disabled": u ? "" : void 0,
          disabled: u,
          value: a,
          ...f,
          ref: w,
          onClick: D(e.onClick, (v) => {
            j(($) => !$), b && (h.current = v.isPropagationStopped(), h.current || v.stopPropagation());
          })
        }
      ),
      b && /* @__PURE__ */ p(
        ee,
        {
          control: d,
          bubbles: !h.current,
          name: o,
          value: a,
          checked: S,
          required: i,
          disabled: u,
          form: m,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
N.displayName = P;
var E = "SwitchThumb", M = c.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...o } = e, r = H(E, n);
    return /* @__PURE__ */ p(
      x.span,
      {
        "data-state": O(r.checked),
        "data-disabled": r.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    );
  }
);
M.displayName = E;
var ee = (e) => {
  const { control: t, checked: n, bubbles: o = !0, ...r } = e, s = c.useRef(null), i = B(n), u = V(t);
  return c.useEffect(() => {
    const a = s.current, l = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (i !== n && f) {
      const d = new Event("click", { bubbles: o });
      f.call(a, n), a.dispatchEvent(d);
    }
  }, [i, n, o]), /* @__PURE__ */ p(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...r,
      tabIndex: -1,
      ref: s,
      style: {
        ...e.style,
        ...u,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function O(e) {
  return e ? "checked" : "unchecked";
}
var te = N, ne = M;
const oe = "_switch__root_ycvcr_1", re = "_switch__thumb_ycvcr_18", _ = {
  switch__root: oe,
  switch__thumb: re
}, fe = A(function({
  id: t,
  required: n,
  checked: o,
  onCheckedChange: r,
  defaultChecked: s,
  disabled: i,
  name: u,
  value: a
}, l) {
  return /* @__PURE__ */ p("div", { className: _.switch, children: /* @__PURE__ */ p(
    te,
    {
      id: t,
      ref: l,
      checked: o,
      onCheckedChange: r,
      defaultChecked: s,
      disabled: i,
      required: n,
      name: u,
      value: a,
      className: _.switch__root,
      children: /* @__PURE__ */ p(ne, { className: _.switch__thumb })
    }
  ) });
});
export {
  fe as S
};
